module.exports = __webpack_public_path__ + "9eb9df80bc804eb3a27c7d86b760a1b7.png";